import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: "https://b1baf5847a28896552a4e7bf42351893@o4505675756208128.ingest.sentry.io/4506250935992320",
	integrations: [
		Sentry.replayIntegration(),
		Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
		Sentry.browserTracingIntegration(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, // Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	enableLogs: true,
	// tracePropagationTargets: [/^https:\/\/hairways.softdefine\.com/],
});

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
